import { useCallback, useEffect } from "react";
import { ConfigProvider, Spin } from "antd";
import { useParams } from "react-router-dom";
import enUS from "antd/locale/en_US";
import {
	getInjections,
	removeInjections,
	saveInjections,
	getInjectionsDict,
} from "service/injectionData";
import EditorTable from "../component/EditorTable";
import useLoading from "components/common/useLoading";
import { titleCase } from "utils/dataUtil";

const injectionColumns = [
	{
		title: "Well Name",
		dataIndex: "well_name",
		key: "well_name",
	},
	{
		title: "Date",
		dataIndex: "inj_date",
		key: "inj_date",
		sorter: (aRec, bRec) => (aRec.inj_date > bRec.inj_date ? 1 : -1),
		width: 120,
	},
];

function InjectionEditor3(props) {
	const { uwi } = useParams();
	const [LoadingIcon, showLoadingIcon, hideLoadingIcon] = useLoading(
		<Spin size="large" />,
		50
	);

	const fetcher = useCallback((uwi, succeed, fail) => {
		getInjections(
			{ uwis: uwi },
			(...values) => {
				succeed(...values);
			},
			(...values) => {
				fail(...values);
			}
		);
	}, []);

	const buildQuery = useCallback(() => {
		return uwi;
	}, [uwi]);

	useEffect(() => {
		getInjectionsDict(
			(res) => {
				let columnKeys = injectionColumns.map((item) => item.key);
				let dictData = res.filter((item) => item.element !== 'uwi' && item.element !== 'well_name' && item.element !== 'inj_date' && !columnKeys.includes(item.element));
				const columns = dictData.map((item) => {
					let name = null;
					if (item.element_fullname) {
						name = item.element_fullname;
					} else {
						name = titleCase(item.element);
					}
					return {
						title: name,
						dataIndex: [item.element, "value"],
						key: item.element,
						width: 120,
					};
				});
				injectionColumns.splice(2, 0, ...columns);
			},
			(error) => {
				console.error(error);
			}
		);
	}, []);

	return (
		<div style={{ height: "91vh", overflowY: "auto" }}>
			<LoadingIcon />
			<ConfigProvider
				locale={enUS}
				componentSize="middle"
				theme={{
					token: {},
					components: {},
				}}
			>
				<EditorTable
					columns={injectionColumns || []}
					title="Well Injection"
					// uwi={uwi}
					// allowNullUwi={false}
					showNewRow={() => false}
					dataFetcher={[
						buildQuery,
						fetcher,
						(data) => {
							let result = [];
							const { injections, wells } = data;
							const recordsMap = new Map();
							const well_name = wells.find(
								(item) => item.uwi === uwi
							)?.well_name;
							const wellInjections = injections[uwi];
							for (let inj_index of Object.keys(
								wellInjections
							)) {
								const injectionItems = wellInjections[inj_index];
								for (const dataItem of injectionItems) {
									const [inj_date, record_id, inj_value] =
										dataItem;
									if (!recordsMap.has(inj_date)) {
										let record = {
											uwi: uwi,
											well_name: well_name,
											inj_date: inj_date,
										};
										recordsMap.set(inj_date, record);
									}
									let record = recordsMap.get(inj_date);
									record[inj_index] = {
										id: record_id,
										value: inj_value || 0,
									};
								}
							}
							result = Array.from(recordsMap.values());
							return result.map((item, index) => {
								return {
									...item,
									id: index,
								};
							});
						},
					]}
					dataSaver={[
						saveInjections,
						(rec, row) => {
							const record = { ...rec };
							const { inj_date } = record;
							delete record.uwi;
							delete record.inj_date;
							delete record.id;
							delete record.well_name;
							let result = {
								uwi,
								inj_date,
								data: {},
							};

							Object.keys(record)
								.filter((key) => key !== "index")
								.map((key) => {
									let dataObj = record[key];
									// console.log("dataObj", dataObj, dataObj.value, typeof dataObj);
									let dataValue = null;
									if (dataObj.value !== undefined) {
										dataValue = dataObj.value;
									} else {
										dataValue = parseInt(dataObj);
									}
									let keyValue = {
										value: dataValue,
									};
									row[key] &&
										(keyValue["id"] = row[key]["id"]);
									result.data[key] = keyValue;
									rec[key] = keyValue;
									return null;
								});
							return [result];
						},
					]}
					dataRemover={[
						removeInjections,
						(record, originData) => {
							const { uwi, inj_date } = record;
							let result = {
								data: [
									{
										uwi,
										date: inj_date,
										data: Object.keys(record).filter(
											(item) =>
												![
													"uwi",
													"inj_date",
													"id",
													"well_name",
												].includes(item)
										),
									},
								],
							};
							return result;
						},
					]}
					loadingIconActions={[showLoadingIcon, hideLoadingIcon]}
				/>
			</ConfigProvider>
		</div>
	);
}

export default InjectionEditor3;
